import { Controller } from "@hotwired/stimulus"

// Saisie manuelle d'une entreprise : fondateurs choisis parmi les personnes existantes.
export default class extends Controller {
  static targets = ["founders", "founderResults", "founderTemplate"]
  static values = { searchUrl: String }

  disconnect() { clearTimeout(this.timer) }

  searchFounders(event) {
    const query = event.currentTarget.value
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      const params = new URLSearchParams({ type: "person", q: query, target: "founders" })
      this.founderResultsTarget.src = `${this.searchUrlValue}?${params}`
    }, 350)
  }

  addFounder(event) {
    const data = event.currentTarget.dataset
    const index = Date.now()
    const card = this.founderTemplateTarget.content.firstElementChild.cloneNode(true)
    card.querySelector("[data-card-label]").textContent = data.label
    card.querySelector("[data-card-meta]").textContent = data.meta || ""
    const id = card.querySelector("[data-founder-field='id']")
    id.name = `company[founders][${index}][id]`
    id.value = data.id
    const select = card.querySelector("[data-founder-field='role']")
    select.name = `company[founders][${index}][role]`
    select.innerHTML = JSON.parse(select.dataset.roles).map(([value, label]) => `<option value="${value}">${label}</option>`).join("")
    this.foundersTarget.appendChild(card)
    this.founderResultsTarget.innerHTML = ""
  }

  removeFounder(event) {
    event.currentTarget.closest(".people-quick-panel__card").remove()
  }
}
